
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as objectTypeActions from './../../../../actions/objectTypeAction';
import ObjectTypes from './ObjectTypes';

const mapStateToProps = state => {
    return {
        objectTypeState: state.objectTypeReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListObjectTypes: (filters) => dispatch(objectTypeActions.getListObjectType(filters)),
        deleteObjectTypeDetail: (objectType, filters) => dispatch(objectTypeActions.deleteObjectTypeDetail(objectType, filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ObjectTypes));
